module.exports = __webpack_public_path__ + "img/7.a1def8a2.jpg";